// @ts-check
import { Checkbox } from '@linearb/linui-common';
import { useContext } from 'react';
import { LoginContext } from '../../../root/views/dashboard/context/LoginContext';
import { Link } from './TermsAndPolicy.style';
import { LINKS } from '../../../../common/consts/links';

export const EnabledGdprConsent = () => {
  const { gdprConsentGiven, setGdprConsentGiven } = useContext(LoginContext);

  return (
    <Checkbox value={gdprConsentGiven} onChange={setGdprConsentGiven}>
      I agree to LinearB’s storage and processing of my personal data <br /> and
      to the{' '}
      <Link href={LINKS.TERMS_LINK} target='__blank'>
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link href={LINKS.PRIVACY_POLICY_LINK} target='__blank'>
        Privacy Policy
      </Link>
    </Checkbox>
  );
};
